<div class="responsive-card">
  <div class="affected-title" *ngIf="!isLoading">{{ memberName }} ({{ memberId | leadingZero : 8 }})</div>
  <div class="affected-title" *ngIf="isLoading">
    <lib-loading-shimmer [height]="'1.5rem'" [width]="'15rem'" />
  </div>
  <div>
    <span class="affected-subtitle" *ngIf="!isLoading">{{accounts?.[0]?.typeId | ipAffectedAccountCardName}}</span>
    <div class="d-flex flex-column">
      <ng-container *ngIf="!isLoading; else shimmer">
        <app-affected-account
          *ngFor="let account of accounts; let last = last"
          [account]="account"
          [lastInList]="last" />
      </ng-container>
    </div>
  </div>
</div>
<ng-template #shimmer>
  <div class="d-flex justify-content-between">
    <div class="d-flex flex-column gap-2">
      <lib-loading-shimmer [height]="'1.5rem'" [width]="'4rem'" />
      <lib-loading-shimmer [height]="'1.5rem'" [width]="'4rem'" />
    </div>
    <lib-loading-shimmer [height]="'1.5rem'" [width]="'8rem'" />
  </div>
  <hr />
  <div class="d-flex justify-content-between">
    <div class="d-flex flex-column gap-2">
      <lib-loading-shimmer [height]="'1.5rem'" [width]="'4rem'" />
      <lib-loading-shimmer [height]="'1.5rem'" [width]="'4rem'" />
    </div>
    <lib-loading-shimmer [height]="'1.5rem'" [width]="'8rem'" />
  </div>
</ng-template>
